export const colorCodingData = [
  '#FF0000',
  '#FF4500',
  '#FF6347',
  '#FF7F50',
  '#FF8C00',
  '#FFA500',
  '#FFD700',
  '#FFFF00',
  '#ADFF2F',
  '#7FFF00',
  '#32CD32',
  '#00FF00',
  '#00FA9A',
  '#00FF7F',
  '#3CB371',
  '#40E0D0',
  '#48D1CC',
  '#20B2AA',
  '#00CED1',
  '#5F9EA0',
  '#4682B4',
  '#1E90FF',
  '#00BFFF',
  '#87CEFA',
  '#6495ED',
  '#4169E1',
  '#0000FF',
  '#8A2BE2',
  '#9400D3',
  '#9932CC',
  '#BA55D3',
  '#800080',
  '#C71585',
  '#DC143C',
  '#FF1493',
  '#FF69B4',
  '#FFB6C1',
  '#FFC0CB',
  '#FF6347',
  '#CD5C5C',
  '#F08080',
  '#E9967A',
  '#FA8072',
  '#FFA07A',
  '#FFDAB9',
  '#EEE8AA',
  '#F0E68C',
  '#BDB76B',
  '#556B2F',
  '#8FBC8F',
];
